import styled, { css } from 'styled-components'

import { Body, Label } from '@nx/fire/typography'

export const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const StyledTitle = styled(Label)`
  color: ${({ theme }) => theme.colours.primary.charcoal};
  margin-bottom: 10px;
`

export const StyledTimeContainer = styled.div`
  display: flex;
  gap: 25px;
`

export const StyledTimeFragment = styled.div<{ $isMinWidth?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  ${({ $isMinWidth = false }) =>
    !$isMinWidth &&
    css`
      width: 34px;
    `}
  ${({ $isMinWidth = false }) =>
    $isMinWidth &&
    css`
      min-width: 34px;
    `}
`

export const StyledTimeTitle = styled(Body)`
  color: ${({ theme }) => theme.colours.primary.charcoal};
`
